import React, { useEffect } from 'react';
import { Container, Row, Col, Carousel, Image } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { chunk, without, range } from 'lodash';
import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import { fetchPasses, fetchCategories } from '../redux/actions/productActions';

const gymNames = {
  'ikea-batu-kawan': 'Project Rock IKEA Batu Kawan',
  'gurney-plaza': 'Project Rock Gurney Plaza',
  'bayana': 'Project Rock Bayana'
};

const TicketItem = ({ gym, col, colWidth }) => {
  const [error, setError] = React.useState(false);

  return (
    <Col sm={12} md={colWidth}>
      <div className="ticket-group">
        <Link to={`/online_ticket/${gym}/${col.toLowerCase().replace(/[ ]+/g, '-')}`}>
          <div>
            {!error ? (
              <Image
                src={`/assets/images/passes/${col}.jpg`}
                className="online-ticket-image"
                onError={() => setError(true)}
              />
            ) : (
              <div className="online-ticket-placeholder">
                <span>{col}</span>
              </div>
            )}
          </div>
        </Link>
        {col === "School Group" &&
          <span>For Kindergarten, and <br></br>Primary/Secondary Schools</span>
        }
      </div>
    </Col>
  );
};

const OnlineTickets = ({ passes, categories, fetchPasses, fetchCategories }) => {

  useEffect(() => {
    fetchPasses();
    fetchCategories();
  }, [fetchPasses, fetchCategories]);

  let { gym } = useParams();
  const gymName = gymNames[gym];

  const column = 2;
  const colWidth = 12 / column;

  let filteredCategories = [];
  if (passes && passes.length > 0) {
    const categoriesForGym = passes
      .filter(pass => pass.enable && pass.gym.includes(gymName))
      .map(pass => pass.category);

    filteredCategories = [...new Set(categoriesForGym)];
  } else {
    filteredCategories = without(categories, 'Pre Sales');
  }

  const rows = chunk(filteredCategories, column);

  return (
    <Layout>
      <Container fluid className="layout online-ticket-box">
        <Row className="space-ptb-10">
          <Col lg={3} xl={3} className="d-none d-lg-block">
            <Sidebar />
          </Col>
          <Col lg={9} xl={6} className="online-ticket-icon">
            {rows && rows.map((cols, i) => {
              return (
                <Row key={i}>
                  {cols.map((col, j) => {
                    return (
                      <TicketItem key={j} gym={gym} col={col} colWidth={colWidth} />
                    )
                  })}
                </Row>
              )
            })}
          </Col>
          <Col xl={3} className="d-none d-xl-block">
            <Carousel controls={false}>
              {range(1, 3).map((i) => {
                return (
                  <Carousel.Item key={i}>
                    <img
                      className="d-block w-100"
                      src={`${process.env.PUBLIC_URL}/assets/images/slider/SliderRight${i}.png`}
                      alt=""
                    />
                  </Carousel.Item>
                )
              })}
            </Carousel>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

const mapStateToProps = (state) => {
  return {
    passes: state.productData.passes,
    categories: state.productData.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPasses: () => {
      dispatch(fetchPasses());
    },
    fetchCategories: () => {
      dispatch(fetchCategories());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OnlineTickets);